var render, staticRenderFns
import script from "./Bar-atribuicaoEstrategia.vue?vue&type=script&lang=js&"
export * from "./Bar-atribuicaoEstrategia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6b68eec')) {
      api.createRecord('b6b68eec', component.options)
    } else {
      api.reload('b6b68eec', component.options)
    }
    
  }
}
component.options.__file = "src/views/pages/Rentabilidade/components/graficos/Bar-atribuicaoEstrategia.vue"
export default component.exports